import styled from 'styled-components';
import { colors, grid } from '_/styles';
import { tokens } from '@plataforma/components';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 1;
  align-items: center;

  margin-bottom: ${grid.large};
`;

export const ListContainer = styled.div`
  width: 864px;
  margin: 24px 32px;
`;

export const Title = styled.h1`
  font-size: 26px;
  font-weight: ${tokens.font.weight.semibold};
  color: ${colors.textMain};
  margin-bottom: 0px;
`;

export const Subtitle = styled.h3`
  font-size: 12px;
  font-weight: ${tokens.font.weight.regular};
  line-height: 16px;
  color: ${colors.textMain};
  margin-bottom: ${grid.medium};
`;
